import { Controller } from '@hotwired/stimulus'

// Scrolls the catalog shelf into view after a text search lands on the page.
export default class extends Controller {
  static values = {
    active: { type: Boolean, default: false },
    anchor: { type: String, default: '' }
  }

  connect () {
    if (this.shouldScroll()) this.scroll()

    this.onTurboLoad = this.onTurboLoad.bind(this)
    document.addEventListener('turbo:load', this.onTurboLoad)
  }

  disconnect () {
    document.removeEventListener('turbo:load', this.onTurboLoad)
  }

  onTurboLoad () {
    if (this.shouldScroll()) {
      requestAnimationFrame(() => this.scroll())
    }
  }

  shouldScroll () {
    const hash = window.location.hash.replace('#', '')
    const paramAnchor = new URLSearchParams(window.location.search).get('anchor')
    const anchors = ['search-results', 'category-shelf', 'shop-directory', 'shop-by-brand']
    if (this.hasAnchorValue && this.anchorValue) anchors.push(this.anchorValue)
    if (hash && anchors.includes(hash)) return true
    if (paramAnchor && anchors.includes(paramAnchor)) return true
    return this.activeValue
  }

  scroll () {
    const id = this.hasAnchorValue && this.anchorValue
      ? this.anchorValue
      : (window.location.hash.replace('#', '') || new URLSearchParams(window.location.search).get('anchor'))
    const target = (id && document.getElementById(id)) || this.element
    if (!target) return

    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
